import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MasterInformationService } from '../../../Services/master-information.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { response } from 'express';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { colorSets } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [NgFor, NgIf, CommonModule, ToastrModule, NgbPaginationModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css'
})
export class NotificationsComponent implements OnInit {

  activeDropdown: any;
  activeTab: string = 'all';

  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 5;

  tableHeaders = ['User ID', 'User Type', 'User Name', 'Mobile No', 'City', 'Zone', 'Notifications']

  tableData: any = [
    {
      userId: 'AB-001',
      userType: 'Individual requestor',
      userName: 'Arun',
      mobileNo: '1236547893',
      city: 'New york',
      zone: 'AlMadinah',
      notificationCategory: 'Create order',
      notifications: 'Order initiated! You will receive call from our Team for Payment Process or Reach our Customer Care 11111111'
    },
    {
      userId: 'AB-002',
      userType: 'Corporate requestor',
      userName: 'Manoj',
      mobileNo: '1236547893',
      city: 'Chicago',
      zone: 'AlAndulas',
      notificationCategory: 'Order placed',
      notifications: 'Payment Received Successfully ! Your Order ID - 1234 Has been Placed'
    },
    {
      userId: 'AB-003',
      userType: 'Dumpster',
      userName: 'Gugan',
      mobileNo: '1236547893',
      city: 'Francisco',
      zone: 'AlMadinah',
      notificationCategory: 'Order received',
      notifications: 'Dear Dumpster, New Container Order received ! Please Accept to proceed further'
    },
    {
      userId: 'AB-004',
      userType: 'DumpYard',
      userName: 'Raja Vignesh',
      mobileNo: '1236547893',
      city: 'Houston',
      zone: 'AlAndulas',
      notificationCategory: 'Order accepted',
      notifications: 'Dear Dump Yard, New Dumping request Received !Please Accept to Dump the Waste Materials'
    },
    {
      userId: 'AB-005',
      userType: 'Corporate requestor',
      userName: 'Vijay',
      mobileNo: '1236547893',
      city: 'Houston',
      zone: 'AlAndulas',
      notificationCategory: 'Order closed',
      notifications: 'Dear Dump Yard, Payment has been received for the Order ID - 1234 is SAR 500 & the Order ID - 1234 has been closed. Thanks You.'
    }
  ];
  originalTableData: any;
  searchText: any;
  allNotification: any;
  filteredNotification: any;
  dumpster: any;
  requestor: any;
  dumpyard: any;
  originalNotifications: any;


  constructor(private masterService: MasterInformationService, private toastr: ToastrService) {

  }

  // ------------------------------ OnInit ------------------------------ //

  ngOnInit() {
    this.getNotification();
  }

  // ------------------------------ Get Notification API ------------------------------ //

  getNotification() {
    this.masterService.getNotification(apiEndPoints.notification).subscribe({
      next: (response: any) => {
        this.originalNotifications = response.body.details;
        this.allNotification = [...this.originalNotifications];
        this.dumpster = this.allNotification.filter((data: any) => data.userType === 'Dumpster')
        this.dumpyard = this.allNotification.filter((data: any) => data.userType === 'Dumpyard')
        this.requestor = this.allNotification.filter((data: any) => data.userType === 'Individual Requester' || data.userType === 'Corporate Requester')
      }
    })
  }

  // ----------------------------- Pagination ----------------------------- //
  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.allNotification?.slice(start, end);
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  availableFilters: { [key: string]: string[] } = {
    City: ['New York', 'Francisco', 'Chicago', 'Houston'],
    Zone: ['AlMadinah', 'AlAndulas'],
    Category: ['Order closed', 'Order accepted', 'Create order', 'Order received', 'Order placed'],
    Status: ['Cancelled', 'Completed', 'Active'],
    UserName: ['Arun', 'Gugan', 'Raja Vignesh', 'Manoj', 'Vijay']
  };

  filteredTableData = [...this.tableData];

  toggleDropdown(row: string): void {
    console.log(row)
    this.activeDropdown = this.activeDropdown === row ? null : row;
  }

  applyFilter(header: string, selectedOption: string): void {
    this.activeDropdown = null;

    if (!selectedOption) {
      this.filteredTableData = [...this.originalTableData];
      return;
    }

    // Filter table data based on the selected option
    this.filteredTableData = this.originalTableData.filter((item: any) =>
      item[header]?.toLowerCase().includes(selectedOption.toLowerCase())
    );
  }


  // --------------------------------------- Search Filter & Nav-Tabs Filter --------------------------------------- //

  applyFilters(): void {
    this.filteredTableData = this.tableData.filter((item: any) => {
      const matchesTab = this.activeTab === 'all' ||
        (this.activeTab === 'requestor' &&
          (item.userType === 'Corporate requestor' || item.userType === 'Individual requestor')) ||
        (this.activeTab === 'individual' && item.userType === 'Individual requestor') ||
        (this.activeTab === 'dumpster' && item.userType === 'Dumpster') ||
        (this.activeTab === 'dumpyard' && item.userType === 'DumpYard');
      const matchesSearch = this.searchText
        ? item.userId.toLowerCase().includes(this.searchText.toLowerCase()) ||
        item.userName.toLowerCase().includes(this.searchText.toLowerCase()) ||
        item.city.toLowerCase().includes(this.searchText.toLowerCase()) ||
        item.userType.toLowerCase().includes(this.searchText.toLowerCase())
        : true;
      return matchesTab && matchesSearch;
    });
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    // Restore original data when switching to the 'all' tab
    if (this.activeTab === 'all') {
      this.allNotification = [...this.originalNotifications];
    } else if (this.activeTab === 'requestor') {
      this.allNotification = this.requestor;
    } else if (this.activeTab === 'dumpster') {
      this.allNotification = this.dumpster;
    } else if (this.activeTab === 'dumpyard') {
      this.allNotification = this.dumpyard;
    }
    // this.applyFilters();
  }

  onSearch(event: any): void {
    this.searchText = event.target.value;
    this.applyFilters();
  }

}
